import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import PasswordInput from 'components/Input/PasswordInput';
import { credentialInstructions } from '../utils';
import NoticeMessage from 'pages/Authorize/Messages/Notice';
import { AppLink } from 'components/Link/AppLink';
import { Box } from '@chakra-ui/react';

const REQUIRED_PERMISSIONS_ARTICLE =
  'https://support.tryfinch.com/articles/8928058988-adp-workforce-now-required-permissions';

export function SignInAdpWorkforceNowCredential({
  isLoading,
  onSubmit,
  client,
  provider,
}: RegisterImplementationProps) {
  const instructions = credentialInstructions(client);

  return (
    <SignInBase
      formLabel={`${provider.displayName} Sign In Form`}
      instructions={instructions}
      onSubmit={onSubmit}
      fieldNames={['username', 'password']}
      render={({ username, password }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <Box pb="1px">
                <NoticeMessage>
                  Please ensure you are assigned the <b>Security Master</b> or{' '}
                  <b>Security Admin</b> role in your ADP Workforce Now account
                  so that a third-party admin can be added. You can confirm your
                  role by following{' '}
                  <AppLink
                    showInFrame
                    target="_blank"
                    href={REQUIRED_PERMISSIONS_ARTICLE}
                    rel="noopener noreferrer"
                  >
                    these instructions
                  </AppLink>
                  .
                </NoticeMessage>
              </Box>
              <Input
                value={username.value}
                onChange={(event) => username.onChange(event.target.value)}
                invalid={username.invalid}
                label="Username"
                id="username"
              />
              <PasswordInput
                reset={{
                  uri: new URL('https://workforcenow.adp.com/'),
                  providerDisplayName: provider.displayName,
                }}
                value={password.value}
                onChange={(event) => password.onChange(event.target.value)}
                invalid={password.invalid}
              />
            </MainContainer>
            <LoaderButton
              text="Connect"
              isLoading={isLoading}
              disabled={isLoading || !username.value || !password.value}
              type="submit"
            />
          </>
        );
      }}
    />
  );
}
